import { gql } from "@apollo/client";

export const VALIDATE_ADDRESS = gql`
  query validateUserAddress($address: ValidateAddressInput) {
    validateAddressV2(address: $address) {
      error
      address {
        street1
        street2
        state
        city
        zip
      }
    }
  }
`;

export const UPDATE_ADDRESS_STEP = gql`
  mutation updateAddressStep(
    $address: AddressInputV2
    $shouldSkipApplicationStepUpdate: Boolean
    $skipAddressVerification: Boolean
  ) {
    updateAddressWithOnboardingStep(
      address: $address
      shouldSkipApplicationStepUpdate: $shouldSkipApplicationStepUpdate
      skipAddressVerification: $skipAddressVerification
    ) {
      status
      message
    }
  }
`;